const ArticleList = () => import('../../components/article-list/index.vue');

export default {
    name: 'ArticleInnerListPage',

    components: {
        'article-list': ArticleList
    }
};